import { SERVICE_ICON_PATHS } from 'blockscope/components/common/BlockscopeServiceIcon';

export const productData = [
  {
    title: 'Tracer',
    description: 'Trace funds moving across wallets, contracts and chains.',
    img: SERVICE_ICON_PATHS.TRACER,
    link: '/products/tracer',
    toolkits: ['Forensics Toolkit'],
  },
  {
    title: 'Transaction Decoder',
    description:
      'All actions involved in a single transaction, decoded & readable.',
    img: SERVICE_ICON_PATHS.TRANSACTION_DECODER,
    link: '/products/transaction-decoder',
    toolkits: ['Observability Toolkit'],
  },
  {
    title: 'Wallet Profiler',
    description:
      'Everything you need to know about a wallet and its on-chain activity.',
    img: SERVICE_ICON_PATHS.WALLET_PROFILER,
    link: '/products/wallet-profiler',
    toolkits: ['Observability Toolkit'],
  },

  {
    title: 'Contract Analysis',
    description: 'Understand smart contract code, functions, events and more.',
    img: SERVICE_ICON_PATHS.CONTRACT_BREAKDOWN,
    link: '/#',
    toolkits: ['Dev Toolkit'],
  },
  {
    title: 'Block Breakdown',
    description:
      'Indepth breakdown of what happened in any block you search for.',
    img: SERVICE_ICON_PATHS.BLOCK_BREAKDOWN,
    link: '/products/block-breakdown',
    toolkits: ['Observability Toolkit'],
  },
  {
    title: 'Watchtower',
    description:
      'No-code tool to monitor, capture and send alerts based on specific on-chain activity.',
    img: SERVICE_ICON_PATHS.WATCHTOWER,
    link: '/products/watchtower',
    toolkits: ['Monitoring Toolkit'],
  },
  {
    title: 'Pipelines',
    description:
      'Send on-chain data to your database in real time. We manage the indexing infra!',
    img: SERVICE_ICON_PATHS.PIPELINES,
    link: '/products/pipelines',
    toolkits: ['Dev Toolkit'],
  },
  {
    title: 'Web3 Directories',
    description:
      'Indexed Data Directories of common entities, contracts, events, functions for easy access to on-chain data.',
    img: SERVICE_ICON_PATHS.WEB_DIRECTORY,
    link: '/products/web-directory',
    toolkits: ['Analytics Toolkit'],
  },
  {
    title: 'Security Monitoring',
    description:
      'Create custom risk rules and monitor smart contracts for vulnerabilities and compliance.',
    img: SERVICE_ICON_PATHS.SECURITY_MONITOR,
    link: '/products/contract-guard',
    toolkits: ['Analytics Toolkit'],
  },
  {
    title: 'Contract Usage',
    description:
      'Retrieve detailed usage activity and interaction data for any contract or protocol.',
    img: SERVICE_ICON_PATHS.CONTRACT_USAGE,
    link: '/products/contract-usage',
    toolkits: ['Analytics Toolkit'],
  },

  {
    title: 'Entity Interactions',
    description:
      'Find and visualize all interactions between on-chain entities.',
    img: SERVICE_ICON_PATHS.ENTITY_INTERACTION,
    link: '/#',
    toolkits: ['Dev Toolkit'],
  },
  {
    title: 'Address Labels',
    description: 'Wallet Labels to understand Identity and Behavior.',
    img: SERVICE_ICON_PATHS.MEMOS,
    link: '/products/api-services',
    toolkits: ['Dev Toolkit'],
  },
  {
    title: 'API Services',
    description: 'Key blockchain data primitives at your fingertips.',
    img: SERVICE_ICON_PATHS.API_SERVICES,
    link: '/products/api-services',
    toolkits: ['Dev Toolkit'],
  },
];

